import React, { useState, useRef, useEffect } from 'react';
import logo from '../../../../assets/images/rio-claro-logo-colorida.svg';
import { ChevronDown, UserCircle } from 'lucide-react';
import SecuritySettingsModal from '../../modals/SecuritySettingsModal';
import EditAccountModal from '../../modals/EditAccountModal';
import PlannerSelect from '../../ui/selects/PlannerSelect';
import { getStoredHeaderPlannerId, setStoredHeaderPlannerId } from '../../../utils/headerPlannerSelection';

const Header = ({ currentAdmin, role, plannerList }) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [showSecuritySettingsModal, setShowSecuritySettingsModal] = useState(false);
  const [showEditAccountModal, setShowEditAccountModal] = useState(false);
  const dropdownRef = useRef();
  const [selectedPlanner, setSelectedPlanner] = useState(() => getStoredHeaderPlannerId(currentAdmin?.id) || 'all');

  const canFilterByPlanner = currentAdmin?.accessProfile?.area === 'operations';

  const planners = [];

  if (plannerList && plannerList.length > 0) {
    planners.push({ value: 'all', label: 'Todos' });
    plannerList.forEach((planner) => {
      planners.push({ value: String(planner.value), label: planner.label });
    });
  }

  useEffect(() => {
    // Quando muda o planner selecionado, adicionamos o query param na URL e persistimos
    const url = new URL(window.location);
    if (selectedPlanner === 'all') {
      url.searchParams.delete('planner_id');
    } else {
      url.searchParams.set('planner_id', selectedPlanner);
    }
    window.history.replaceState({}, '', url);
    setStoredHeaderPlannerId(currentAdmin?.id, selectedPlanner);
  }, [selectedPlanner, currentAdmin?.id]);

  // Fecha o dropdown ao clicar fora
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleModalSuccess = () => {
    setShowEditAccountModal(false);
    setShowSecuritySettingsModal(false);
  };

  return (
    <header className="flex items-center justify-between bg-white px-6 py-4 relative">
      <div className="flex items-center space-x-3">
        <img src={logo} alt="Rio Claro Investimentos" className="h-12 px-6" />
      </div>

      <div className="flex items-center gap-5">
        {canFilterByPlanner && (
          <PlannerSelect
            value={selectedPlanner}
            onChange={(e) => setSelectedPlanner(e.target.value)}
            options={planners}
          />
        )}

        <div className="relative text-blueDark" ref={dropdownRef}>
          <button
            onClick={() => setDropdownOpen(!dropdownOpen)}
            className="flex items-center space-x-3 focus:outline-none"
          >
            {currentAdmin.avatarUrl ? (
              <img src={currentAdmin.avatarUrl} alt="Avatar" className="w-10 h-10 rounded-full object-cover" />
            ) : (
              <UserCircle className="w-10 h-10 text-blueMedium" />
            )}
            <div className="text-right">
              <p className="text-lg">
                Olá, <span className="font-bold">{currentAdmin.fullName}</span>
              </p>
              <p className="text-xs text-left">{role === 'planner' ? 'PLANEJADOR' : 'ANALISTA'}</p>
            </div>
            <ChevronDown className="w-5 h-5 text-blueMedium" />
          </button>

          {dropdownOpen && (
            <div className="absolute right-0 mt-2 w-full bg-white border border-bluePale rounded-lg shadow-lg z-50">
              <ul className="divide-y divide-grayLight">
                <li>
                  <button
                    onClick={() => {
                      setShowEditAccountModal(true);
                      setDropdownOpen(false);
                    }}
                    className="block w-full text-left px-4 py-2 text-sm text-blueDark hover:bg-gray-100"
                  >
                    Informações da conta
                  </button>
                </li>
                <li>
                  <button
                    onClick={() => {
                      setShowSecuritySettingsModal(true);
                      setDropdownOpen(false);
                    }}
                    className="block w-full text-left px-4 py-2 text-sm text-blueDark hover:bg-gray-100"
                  >
                    Segurança
                  </button>
                </li>
              </ul>
            </div>
          )}
        </div>
      </div>

      {showSecuritySettingsModal && (
        <SecuritySettingsModal onClose={() => setShowSecuritySettingsModal(false)} onSuccess={handleModalSuccess} />
      )}

      {showEditAccountModal && (
        <EditAccountModal onClose={() => setShowEditAccountModal(false)} onSuccess={handleModalSuccess} />
      )}
    </header>
  );
};

export default Header;
